/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'formik';
import { Button, CircularProgress, Select, FormControl, FormControlLabel, Grid, InputLabel, Switch, FormHelperText, MenuItem, LinearProgress } from '@mui/material';
import { useEffect } from 'react';
import { getAllRole } from '../../../../../../../../store/reducers/role/roleAction';
import { getAllDevice } from '../../../../../../../../store/reducers/device/deviceAction';
import { getAllOrg } from '../../../../../../../../store/reducers/organization/organizationAction';
import { getAllAppsByOrgID } from '../../../../../../../../store/reducers/organization/orgApp/orgAppAction';

const OrgAppDeviceForm = ({ errors, touched,
    values, handleBlur, handleChange, setFieldValue, handleClose, isSubmitting }) => {
    const [orgApps, setOrgApps] = useState({});
    const [orgId, setOrgId] = useState("");
    const [loadingSearch, setLoadingSearch] = useState(false);
    const roles = useSelector(state => state.role.roles);
    const devices = useSelector(state => state.device.devices);
    const dispatch = useDispatch();
    const organizations = useSelector(state => state.organization.organizations);
    const orgAppList = useSelector(state => state.orgApp.orgAppList);
    useEffect(() => {
        dispatch(getAllRole());
        dispatch(getAllDevice());
        dispatch(getAllOrg());
    }, [dispatch]);
    const handleOrgChange = async (orgID) => {
        try {
            setOrgApps({});
            setOrgId(orgID);
            setLoadingSearch(true);
            await dispatch(getAllAppsByOrgID({ organizationID: orgID })).unwrap()
            setLoadingSearch(false)
        } catch (error) {
            setLoadingSearch(false)
        }
    }
    useEffect(() => {
        if (orgId) {
            setOrgApps(orgAppList);
        }
    }, [orgAppList, orgId]);
    return (


        <Form>

            <Grid container spacing={4}>
                {values.hasOwnProperty("organizationID") &&
                    <Grid item xs={12} md={12} sm={12}>


                        <FormControl fullWidth error={Boolean(touched.organizationID && errors.organizationID)}>
                            <InputLabel htmlFor="outlined-status">Organization</InputLabel>
                            <Select
                                value={values.organizationID}
                                variant="outlined"
                                name="organizationID"
                                label="Owner"
                                onBlur={() => handleOrgChange(values.organizationID)}
                                onChange={handleChange}
                                style={{ color: 'white' }}
                            >
                                {organizations?.Records?.length > 0 && organizations?.Records?.map((item) => (
                                    <MenuItem value={item.organizationID}>
                                        {item.organizationName}
                                    </MenuItem>
                                ))}


                            </Select>
                            {errors.organizationID && <FormHelperText style={{ color: "red" }} >{errors.organizationID}</FormHelperText>}

                        </FormControl>

                    </Grid>}
                {values.hasOwnProperty("organizationApplicationID") && <Grid item xs={12} md={12} sm={12}>


                    <FormControl fullWidth error={Boolean(touched.organizationApplicationID && errors.organizationApplicationID)}>
                        {loadingSearch && <LinearProgress color="success" sx={{ margin: '10px' }} />}

                        <InputLabel htmlFor="outlined-status">Application</InputLabel>

                        <Select
                            value={values.organizationApplicationID}
                            variant="outlined"
                            name="organizationApplicationID"
                            label="Organization Application"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                            {orgApps?.Records?.length > 0 && orgApps?.Records?.map((item, index) => (
                                <MenuItem value={item.organizationApplicationID} key={index}>
                                    {item.applicationName}
                                </MenuItem>
                            ))}

                        </Select>
                        {errors.organizationApplicationID && <FormHelperText style={{ color: "red" }} >{errors.organizationApplicationID}</FormHelperText>}

                    </FormControl>

                </Grid>}
                {values.hasOwnProperty("deviceID") && <Grid item xs={12} md={12} sm={12}>


                    <FormControl fullWidth error={Boolean(touched.deviceID && errors.deviceID)}>
                        <InputLabel htmlFor="outlined-status">Device</InputLabel>
                        <Select
                            value={values.deviceID}
                            variant="outlined"
                            name="deviceID"
                            label="Device"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                            {devices?.Records?.length > 0 && devices?.Records?.map((item) => (
                                <MenuItem value={item.deviceID}>
                                    {item.deviceName}
                                </MenuItem>
                            ))}


                        </Select>
                        <FormHelperText style={{ color: "red" }} >{errors.deviceID}</FormHelperText>

                    </FormControl>

                </Grid>}

                <Grid item xs={12} md={12} sm={12}>


                    <FormControl fullWidth error={Boolean(touched.roleID && errors.roleID)}>
                        <InputLabel htmlFor="outlined-status">Role</InputLabel>
                        <Select
                            value={values.roleID}
                            variant="outlined"
                            name="roleID"
                            label="Role"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            style={{ color: 'white' }}
                        >
                            {roles?.length > 0 && roles?.map((item) => (
                                <MenuItem value={item.roleID}>
                                    {item.roleName}
                                </MenuItem>
                            ))}


                        </Select>
                        <FormHelperText style={{ color: "red" }} >{errors.roleID}</FormHelperText>

                    </FormControl>

                </Grid>
                {values.hasOwnProperty("detailValue") && <Grid item xs={12} md={6} sm={6}>
                    <FormControlLabel
                        control={<Switch />}
                        name="organizationDeviceDetails"
                        checked={values.detailValue === "true"}
                        onChange={(event, checked) => {
                            setFieldValue("detailValue", checked ? "true" : "false");
                        }}
                        label={values.detailValue === "true" ? 'Authorized' : 'Unauthorized'}
                    />
                </Grid>}
                <Grid item xs={12} md={12} sm={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit" style={{ marginTop: '20px' }}
                        disabled={isSubmitting}>
                        {isSubmitting &&
                            <CircularProgress size={24} color='success' style={{ marginLeft: '10px' }} />} Save
                    </Button>
                    <Button variant="outlined" onClick={() => handleClose()} style={{ marginTop: '20px', marginLeft: '10px' }}>close</Button>

                </Grid>

            </Grid>
        </Form>

    )

}

export default OrgAppDeviceForm;